import { createEffect, createEvent, sample } from 'effector'
import { appearanceFeature } from '~/features/appearance'
import { Logger } from '~/shared/logger'
import { updateRoutes } from './spaces/modules'

// application top-level routes
export { route } from './spaces'

export const logger = new Logger('tria/processes/routing')

// initialize process
export const init = createEvent()

const updateRoutesFx = createEffect(updateRoutes)

sample({
  clock: appearanceFeature.$modules,
  target: updateRoutesFx,
})
